export default class UgcClient {
  constructor({ url, _get, _post, _put }) {
    this.url = url
    this.post = _post
    this.get = _get
    this.put = _put
  }

  help() {
    console.log('newUgc(exhibit, fullFileUrl, email, name)')
    console.log('save(ugc)')
    console.log('getPresignedUrl(presign)')
    console.log('upload(file, presignedUrl)')
  }

  newUgc(exhibit, urls, email, name) {
    urls = urls || []
    const s3Files = urls.map(f => (f || '').split('?')[0])

    return {
      orgId: exhibit.orgId,
      appId: exhibit._id,
      s3Files,
      email,
      name
    }
  }

  async save(ugc) {
    const url = `${this.url}/api/v2/ugc/create`

    const resp = await this.post(url, { ugc }, 'failed')
    const errors = resp === 'failed' ?  ['Failed to save ugc content'] : []

    return { errors }
  }

  async getPresignedUrl(presign){
    if(!presign) presign = {}

    const url = `${this.url}/api/v2/ugc/presign_url`
    const fallback = { errors: ['Failed to generate presignedUrl'], presignedUrl: undefined, fullFileUrl: undefined }

    return this.post(url, presign, fallback)
  }

  async upload(fileUpload){
    const headers = {'Content-Type': fileUpload.type}
    const resp = await this.put(fileUpload.presignedUrl, fileUpload.data, { headers }, 'failed')

    if(resp === 'failed') {
      return { errors: ['Failed to upload file to S3'], uploaded: false }
    }else{
      return { errors: [], uploaded: true }
    }
  }
}
